import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '@services/core/auth.service';
import { Global } from '@services/core/Global';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { QueryUtils } from 'app/core/utils/query.utils';

@Injectable()
export class PartyOverviewService {
  public url: string;
  public url_declaracion: string;
  public identity;

  private authService = inject(AuthService);

  constructor(
    private _http: HttpClient,
    private _microsoftAuth: MicrosoftAuthService
  ) {
    this.url = Global.url;
  }



  getDocumentView(params) {
    const queryParams = QueryUtils.convertToFilter(params);
    return this._http.get(this.url + 'V1/documents-view', { params: queryParams });
  }

  updateParty(params) {
    return this._http.put(this.url + 'V1/party/' + params.uuid, params);
  }

  getVehicleView(params) {
    const queryParams = QueryUtils.convertToFilter(params);
    return this._http.get(this.url + 'V1/vehicles-view', { params: queryParams });
  }

  private cleanNumericValue(value: any): string {
    if (typeof value === 'string' && value.length > 0) {
      // Elimina puntos (miles) y cambia coma por punto (decimal)
      return value.replace(/\./g, '').replace(',', '.');
    }
    return value;
  }

  private cleanVehicleParams(params: any): any {
    const cleaned = { ...params };
    if (cleaned.commercialValue) cleaned.commercialValue = this.cleanNumericValue(cleaned.commercialValue);
    if (cleaned.value) cleaned.value = this.cleanNumericValue(cleaned.value);
    if (cleaned.km) cleaned.km = this.cleanNumericValue(cleaned.km); // También km por si acaso
    return cleaned;
  }

  updateVehicle(params) {
    const cleanedParams = this.cleanVehicleParams(params);
    return this._http.put(this.url + 'V1/vehicles/' + cleanedParams.id, cleanedParams);
  }

  createVehicle(params) {
    const cleanedParams = this.cleanVehicleParams(params);
    return this._http.post(this.url + 'V1/vehicles', cleanedParams);
  }

  // Actualizar documento con archivo
  updateDocument(uuid: string, formData: FormData) {
    return this._http.put(this.url + 'V1/documents/upload/' + uuid, formData);
  }

  createTransferRequest(params: any) {
    return this._http.post<any>(this.url + 'V1/requests', params);
  }

  getRequest(params) {
    const queryParams = QueryUtils.convertToFilter(params);
    return this._http.get(this.url + 'V1/requests', { params: queryParams });
  }

  getPartyRequests(partyUuid: string) {
    return this._http.get<any[]>(`${this.url}V1/requests/party/${partyUuid}`);
  }

  resendToken(requestId: number) {
    return this._http.post(`${this.url}V1/requests/${requestId}/resend-token`, {});
  }

}
